import React from 'react';
import { Row, Col } from "antd";
import CardTotalSpotsHolder from './Styles/cardTotalSpotsStyle';
import PlayoutsLabelContainer from '../newSrc/features/campaignManager/containers/step2_settings/PlayoutsLabelContainer';

const CardTotalSpotsComponent = (props) => {
  const { stepsCurrent, customContents } = props;

  const calculateTotalPromiseShow = () => {
    if (!customContents || !Array.isArray(customContents)) return 0;
    return customContents.reduce((total, item) => total + (item.promised_shows || 0), 0);
  };

  return (
    <CardTotalSpotsHolder hasRedistribute={stepsCurrent > 1}>
      <div className="cardGeneral">
        <Row justify="center">
          <Col>
            <div>
              <div className='infoTotalSpots'><PlayoutsLabelContainer /></div>
              <div className='totalSpotsContainer'>
                <p className='totalSpots'>{calculateTotalPromiseShow()}</p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </CardTotalSpotsHolder>
  );
};

export default CardTotalSpotsComponent;